const dictionary = {
  search: 'common.search',
  reset: 'common.reset',
  retract: 'common.retract',
  expansion: 'common.expansion',
}

export { dictionary }
